import './project-chat-view.css';

import { EmptyState } from '@kerfjs/ui/empty-state';
import type { SafeHtml } from 'kerfjs';

import { chatActiveId } from '../../../data/state.js';
import { ChatComposer } from './chat-composer.js';
import { ChatConversation } from './chat-conversation.js';

export function ProjectChatView(): SafeHtml {
  if (chatActiveId.value === '') {
    return (
      <EmptyState
        title="Start a Project Chat"
        detail="Start an organization chat across retained procurement records, or choose a project chat. Chats are shared with teammates who can access Chat."
      />
    );
  }
  return (
    <section class="project-chat-view" aria-label="Project Chat">
      <ChatConversation emptyText="Ask across this project and the organization knowledge base. Mention a demand when you want the assistant to pull its current details." />
      <div class="project-chat-composer">
        <ChatComposer />
      </div>
    </section>
  );
}
